import { combineReducers } from 'redux'
import { createMigrate, persistReducer, PersistConfig } from 'redux-persist'
import { MigrationManifest } from 'redux-persist/es/types'
import sessionStorage from 'redux-persist/lib/storage/session'

import { searchbarReducer as searchbar } from './searchbar'
import { reducer as user } from './user'
import { reducer as wishlist } from './wishlist'
import { filtersReducer as filters } from './filters'
import { bulkInquiryReducer } from './bulk-inquiry'
import BulkInquiryState from './bulk-inquiry/types'
import bulkInquiryMigrations from './bulk-inquiry/migrations'
import { getRelativeURL } from '../utils/encoding-utils'
import config from '../common/config'

// A searchbar re-search (new dates/guests/region) is a hard navigation, so this slice gets
// restored from sessionStorage before the SPA-only `setFilterContext` sync ever runs (see
// `useSyncSelectionFilter`). `stateReconciler` is the reconciliation point: unlike `transforms`
// (which redux-persist invokes once per top-level field, not once for the whole slice), it
// receives the fully reassembled persisted state, so it's safe to compare `filterKey` here
// against the live URL and drop the tray when the search itself has changed.
const bulkInquiryStateReconciler = (
    inboundState: BulkInquiryState,
    _originalState: BulkInquiryState,
    reducedState: BulkInquiryState,
): BulkInquiryState => {
    const currentFilter = getRelativeURL('', { encoded: false })
    if (inboundState?.filterKey !== currentFilter) {
        return { ...reducedState, filterKey: currentFilter, selectedListings: {}, selectionOrder: [] }
    }
    return { ...reducedState, ...inboundState }
}

const bulkInquiryPersistConfig: PersistConfig<BulkInquiryState> = {
    key: 'bulkInquiry',
    version: 1,
    storage: sessionStorage,
    stateReconciler: bulkInquiryStateReconciler,
    migrate: createMigrate(bulkInquiryMigrations as unknown as MigrationManifest, {
        debug: config.environment !== 'production',
    }),
}

const bulkInquiry = persistReducer(bulkInquiryPersistConfig, bulkInquiryReducer)

const rootReducer = combineReducers({ searchbar, user, wishlist, filters, bulkInquiry })

export default rootReducer
